<section class="w-full overflow-hidden rounded-[1.4rem] bg-lSurface shadow-panel">
  <div class="h-6 w-full bg-gradient-brand"></div>

  <div class="flex flex-col items-center gap-5 px-4 py-6 md:flex-row md:justify-center md:gap-8 md:px-12 md:py-20">
    @if (isCompleted) {
      <img
        src="assets/icons/medal.svg"
        alt="Medalha de curso concluído"
        class="h-24 w-24 shrink-0 md:h-52 md:w-48"
      />
    } @else {
      <div class="relative h-24 w-24 shrink-0 rounded-full p-3 md:h-28 md:w-28" [style.background]="ringBackground">
        <div class="flex h-full w-full items-center justify-center rounded-full bg-lSurface text-3xl font-semibold text-lWhite">
          <span class="text-3xl md:text-4xl">{{ progressText }}</span>
        </div>
      </div>
    }

    <div class="flex flex-col items-center text-center md:items-start md:text-left">
      <h3 class="text-2xl font-semibold leading-tight text-lWhite">{{ title }}</h3>
      <p class="mt-1 text-base text-lWhite/45">{{ subtitle }}</p>

      <button lButton type="button" [bType]="buttonTypeEnum.PRIMARY" [bRadius]="buttonRadiusEnum.CIRCLE" [bSize]="buttonSizeEnum.MEDIUM" class="mt-5 !min-w-72 !shadow-none">
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</section>
